

import React from "react";


class About extends React.Component{
    constructor(props){
        super(props);

    }
    render(){
        return(
              <h1>This is about us</h1>
             )

    }
}




export default About;